import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import styles from './PropertiesTab.module.scss';

const PropertiesTab = ({
  className,
  active,
  disabled,
  label,
  onClick,
}: {
  className: any;
  active: any;
  disabled: any;
  label: any;
  onClick: any;
}) => (
  <div
    className={cn(
      styles.tab,
      { [styles.tabActive]: active, [styles.tabDisabled]: disabled },
      className,
    )}
    onClick={() => {
      if (disabled) {
        return;
      }
      onClick(label);
    }}
  >
    <Typography
      className={styles.text}
      variant="body3"
      weight="medium"
      mode="compact"
    >
      {label}
    </Typography>
  </div>
);

export default React.memo(PropertiesTab) as any;
